import Config from "@Config";

export const postcode = {
    ID: "vaxiplace-postcode",
    validate: input => {
        return Config.Regex.postcode.test(input.value);
    },
    error: `Please enter a valid postcode.`,
};

export const password = {
    ID: "vaxiplace-password",
    validate: input => {
        return Config.Regex.password.test(input.value);
    },
    error: `Your password must be at least 6 letters and 1 number.`,
};

export const ahpraNumber = {
    ID: "ahpraNumber",
    validate: input => {
        return Config.Regex.ahpraNumber.test(input.value);
    },
    error: `Please enter a valid AHPRA number.`,
};

export const strictPasswordValidator = {
    ID: "vaxiplace-password-strict",
    validate: input => {
        if (
            Config.Regex.passwordDigits.test(input.value) +
                Config.Regex.passwordSpecialCharacters.test(input.value) +
                Config.Regex.passwordLowercase.test(input.value) +
                Config.Regex.passwordUppercase.test(input.value) >=
                3 &&
            Config.Regex.passwordLength.test(input.value) === true
        ) {
            return true;
        }
        return false;
    },
    error: "Please make sure the password meets all the requirements.",
};

export default [password, ahpraNumber, strictPasswordValidator];
